import React from "react";
import PageTitle from "sc/ui/sites/oncall/components/PageTitle";
import { Row, Col, Panel } from "react-bootstrap";
import { connect } from "react-redux";
import { partner } from "../../selectors/partners";
import { partnerPageLoad, partnerAddRequest } from "../../actions/partners";
import { push } from "react-router-redux";
import PartnerForm from "../../components/forms/Partner";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";

export default connect(
  (state, ownProps) => ({
    partner: partner(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(partnerPageLoad()),
    onSave: formData => dispatch(partnerAddRequest(formData)),
    onPartnerList: () => dispatch(push("/")),
  }),
)(
  componentWithLoadTrigger(props => {
    if (props.partner === null) return <div />;
    return (
      <div id="add-partner-page">
        <PageTitle title="Add a partner" />
        <div>
          <a
            id="back"
            style={{ cursor: "pointer" }}
            onClick={props.onPartnerList}
          >
            <span className="glyphicon  glyphicon-circle-arrow-left" />
            Back to partners list
          </a>
        </div>
        <br />
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Partner data</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <PartnerForm
                  partner={props.partner}
                  onSave={props.onSave}
                  disabled={props.partner.generalDataSaveInProgress}
                  backendError={props.partner.generalDataError}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/admin/AddPartnerPage.js